"use client";

import { getKeyByValue } from "@/utils/core-functions";
import { useRouter } from "next/navigation";
import { LocalesList, LocaleType } from "./types";
import domains from "../../../config/domain-map.json";

const useChangeLocale = () => {
  const router = useRouter();

  const changeLocale = (locale: LocaleType) => {
    if (!LocalesList.includes(locale)) return;

    const domain = getKeyByValue(domains, locale);

    if (!domain) return;

    router.push(`https://${domain}`);
  };

  return changeLocale;
};

export default useChangeLocale;
